module.exports = __webpack_public_path__ + "img/08_maska_mazok_3.7f39020.svg";